import { PropsWithChildren, createContext, useContext, useState } from "react"

export const TestingContext = createContext<ReturnType<typeof useCreateTestingContext> | null>(null)

export const useCreateTestingContext = (appSyncApiKey?: string | null) => {
  return { appSyncApiKey }
}

export const useTestingContext = () => {
  const context = useContext(TestingContext)

  if (!context) {
    throw new Error("useTestingContext must be used within a TestingContextProvider")
  }

  return context
}

export const TestingContextProvider = ({
  children,
  appSyncApiKey,
}: PropsWithChildren & { appSyncApiKey?: string | null }) => {
  const context = useCreateTestingContext(appSyncApiKey)

  return <TestingContext.Provider value={context}>{children}</TestingContext.Provider>
}
